export const DEFAULT_OTP_METHOD = 'email';

// Routes that are open without a session.
export const PUBLIC_ROUTES = ['login', 'reset-password', 'register', 'decline'];
